import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import update from 'immutability-helper';
import EnquiryParams from './enquiryParams';
import ProductHeader from './header/productHeader';
import { addToRecentlyViewed } from './helper/recentVehiclesHelper';
import localStorageAvailable from '@helpers/localStorage';

export default class ProductPageContainer extends Component {
  static displayName = 'ProductPageContainer';
  static propTypes = {
    authenticityToken: PropTypes.string,
    clickAndCollectAvailable: PropTypes.bool,
    deliveryPreferences: PropTypes.object,
    enquiryPath: PropTypes.string,
    experiments: PropTypes.object.isRequired,
    livePersonAvailable: PropTypes.bool,
    location: PropTypes.string,
    quotationsAvailable: PropTypes.bool,
    reservationAvailable: PropTypes.bool,
    vehicle: PropTypes.object,
    whatsAppAvailable: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      deliveryPreferences: {
        preference: 'NONE',
      },
      enquiry: {
        dealbuilder: false,
        finance: {},
        interestedInFinance: false,
      },
      finance: {
        selectedFinance: this.initialSelectedFinance(),
        ...this.props.vehicle.finance,
        isDepositSaved: this.props.vehicle.isDepositSaved,
      },
      pricing: this.props.vehicle.pricing,
    };
  }

  componentDidMount() {
    EventEmitter.on(EVENT_TYPES.calculatedHpUpdate, this.updateHP);
    EventEmitter.on(EVENT_TYPES.calculatedPcpUpdate, this.updatePCP);
    EventEmitter.on(EVENT_TYPES.changedFinance, this.updatePricing);

    if (localStorageAvailable()) {
      addToRecentlyViewed(this.props.vehicle.stockReference);
    }
  }

  initialSelectedFinance() {
    if (this.props.vehicle.finance.contract_hire) return 'contract_hire';
    if (this.props.vehicle.finance.pcp) return 'pcp';
    if (this.props.vehicle.finance.hp) return 'hp';
  }

  getValueFromString = (string) => parseFloat(string.replace(/[£,]/g, ''));

  updatePCP = (illustration) => {
    const mileage = this.getValueFromString(illustration['Annual mileage']);
    this.setState(
      update(this.state, {
        finance: {
          pcp: {
            illustration: { $set: illustration },
            calculator: {
              initialDeposit: { $set: illustration['Deposit'] },
              initialTerm: {
                $set: illustration['Term (months)'],
              },
              initialAnnualMileage: { $set: mileage },
            },
          },
        },
        pricing: {
          deposit: { $set: illustration['Deposit'] },
          monthlyPayment: {
            $set: illustration['Monthly payment'],
          },
        },
      })
    );
  };

  updateHP = (illustration) => {
    this.setState(
      update(this.state, {
        finance: {
          hp: {
            illustration: { $set: illustration },
            calculator: {
              initialDeposit: { $set: illustration['Deposit'] },
              initialTerm: {
                $set: illustration['Term (months)'],
              },
            },
          },
        },
        pricing: {
          deposit: { $set: illustration['Deposit'] },
          monthlyPayment: {
            $set: illustration['Monthly payment'],
          },
        },
      })
    );
  };

  updatePricing = (financeType, deposit, monthlyPayment) => {
    this.setState(
      update(this.state, {
        finance: {
          selectedFinance: { $set: financeType },
        },
        pricing: {
          deposit: { $set: deposit },
          monthlyPayment: { $set: monthlyPayment },
        },
      })
    );
  };

  updateDeliveryPreferences = (preferences) => {
    this.setState({ deliveryPreferences: preferences });
  };

  submitEnquiryParamsForm() {
    EventEmitter.emit(EVENT_TYPES.submitEnquiryForm);
  }

  clickAndCollectPostcode() {
    if (!localStorageAvailable()) return null;
    return localStorage.getItem('postcode');
  }

  render() {
    return (
      <>
        <EnquiryParams
          authenticityToken={this.props.authenticityToken}
          clickAndCollectAvailable={this.props.clickAndCollectAvailable}
          deliveryPreferences={this.state.deliveryPreferences}
          enquiry={this.state.enquiry}
          enquiryPath={this.props.enquiryPath}
          finance={this.state.finance}
        />

        <ProductHeader
          authenticityToken={this.props.authenticityToken}
          clickAndCollectAvailable={this.props.clickAndCollectAvailable}
          deliveryPreferences={this.state.deliveryPreferences}
          enquiryPath={this.props.enquiryPath}
          experiments={this.props.experiments}
          finance={this.state.finance}
          livePersonAvailable={this.props.livePersonAvailable}
          phoneNumber={this.props.vehicle.branch.phone}
          pricing={this.state.pricing}
          quotationsAvailable={this.props.quotationsAvailable}
          reservationAvailable={this.props.reservationAvailable}
          submitEnquiryParamsForm={this.submitEnquiryParamsForm}
          updateDeliveryPreferences={this.updateDeliveryPreferences}
          userLocation={
            this.props.deliveryPreferences?.location ||
            this.props.location ||
            this.clickAndCollectPostcode()
          }
          vehicle={this.props.vehicle}
          whatsAppAvailable={this.props.whatsAppAvailable}
        />
      </>
    );
  }
}
